var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 261,
    viewBox: "0 0 297 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38195 214.482C6.38195 214.482 2.74944 197.801 33.3244 188.266C63.8995 178.731 83.5745 196.038 109.484 186.298C135.394 176.558 182.277 160.601 229.167 175.936C276.057 191.271 191.999 212.255 224.499 227.228C251.612 239.716 174.749 262.89 123.727 247.128C72.4345 231.274 48.8619 242.776 26.3244 235.628C3.78695 228.48 6.38195 214.482 6.38195 214.482Z",
    fill: "#C12E2A",
    fillOpacity: 0.152941
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38195 207.482C6.38195 207.482 2.74944 190.801 33.3244 181.266C63.8995 171.731 83.5745 189.038 109.484 179.298C135.394 169.558 182.277 153.601 229.167 168.936C276.057 184.271 191.999 205.255 224.499 220.228C251.612 232.716 174.749 255.89 123.727 240.128C72.4345 224.274 48.8619 235.776 26.3244 228.628C3.78695 221.48 6.38195 207.482 6.38195 207.482Z",
    fill: "#C12E2A",
    fillOpacity: 0.152941
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_441_93",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 0,
    width: 250,
    height: 250
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M297 0H47V250H297V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_441_93)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_441_93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.754 43.349C216.181 101.279 173.526 139.271 128.769 210.051C128.561 210.384 128.28 210.664 127.947 210.87C127.614 211.077 127.238 211.204 126.848 211.241C126.458 211.279 126.064 211.227 125.698 211.088C125.331 210.949 125.001 210.728 124.734 210.441L53.929 133.759C53.6962 133.507 53.5166 133.21 53.4011 132.887C53.2855 132.564 53.2363 132.221 53.2563 131.878C53.2764 131.536 53.3653 131.201 53.5179 130.893C53.6704 130.586 53.8833 130.312 54.144 130.089L92.744 97.014C93.0178 96.7792 93.3383 96.6051 93.6844 96.5032C94.0304 96.4012 94.3941 96.3738 94.7515 96.4227C95.1089 96.4716 95.4519 96.5957 95.7579 96.7868C96.0638 96.978 96.3258 97.2318 96.5265 97.5315L124.219 138.817C197.474 74.3415 260.911 47.9265 287.369 38.9165C290.091 37.989 292.016 41.569 289.754 43.349Z",
    fill: "url(#paint0_linear_441_93)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_441_93",
    x: 48.252,
    y: 38.7656,
    width: 247.5,
    height: 182.488,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_441_93"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_441_93",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_441_93",
    x1: 172.002,
    y1: 38.7656,
    x2: 172.002,
    y2: 211.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A2D1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06B3E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.768e7655aeddf673b530c894985d064b.svg";
export { ForwardRef as ReactComponent };